import { gql } from '@apollo/client';
import { genericFields } from './index';
import { graphql } from '../../graphql';

export const itemsFragment = gql`
  fragment itemFields on ESItem {
    ${genericFields}
    isBusiness
    photos(limit: 1) {
      thumbnail
      f460x345
    }
  }
`;

export const ISRCurrentItemFragment = graphql(`
  fragment ISRCurrentItemFields on Item {
    id
    address
    buildingTypeName
    contactTypeName
    breadcrumbs {
      name
      path
    }
    description
    leased
    updatedAt
    rooms
    floor
    floors
    metaTags {
      name
      content
    }
    hasBillOfSale
    hasMortgage
    hasRepair
    state
    isExpiredManually
    contactName
    expiresAt
    views
    isFeatured
    isVipped
    landArea {
      units
      value
    }
    area {
      units
      value
    }
    price {
      currency
      total
      perAre
    }
    paidDaily
    photos {
      full
      f660x496
      thumbnail
    }
    category {
      id
      hasFloor
      hasLandArea
      name
      pluralName
      slug
      title
    }
    city {
      id
      name
      path
      slug
    }
    company {
      id
      name
      targetType
    }
    path
    location {
      fullName
      path
    }
    business {
      ... on Agency {
        id
        logoUrl
        name
        path
        schedule
        contactAddress
        latitude
        longitude
        itemsCount
        viewsCount
        city {
          name
        }
      }
      ... on Residence {
        id
        website
        logoUrl
        contactEmail
        path
        companyName
        apartments {
          nodes {
            area
          }
        }
        deadline
        hasBillOfSale
        price {
          currency
          total {
            maximum
            minimum
          }
        }
        address
        lat
        lng
        schedule
        city {
          name
        }
      }
    }
    nearestLocations {
      ... on Location {
        path
        fullName
        id
      }
      ... on City {
        path
        name
        id
      }
    }
  }
`);
